import { RouteLocation, Router } from 'vue-router'
import { computed } from 'vue'

// getModalStackFromRoute returns all modal routes belonging to the given route.
const getModalStackFromRoute = (route: RouteLocation) => {
  if (route.matched) {
    const modalStack = route.matched.filter((route) => route.meta.isModal)
    if (modalStack) {
      return modalStack
    }
  }
  return []
}

export function useModalStack (router: Router) {
  const stack = computed(() => getModalStackFromRoute(router.currentRoute.value))

  const close = async () => {
    const currentRoute = router.currentRoute.value

    const parent = currentRoute.matched[currentRoute.matched.length - 2]
    if (parent) {
      const params: Record<string, string> = {}

      // RecycleRouteParams allows recycling route params when navigating back to a parent route.
      // The child route's param is used as the parent route's param with the same name when navigating.
      if (parent.meta.recycleRouteParams && Array.isArray(parent.meta.recycleRouteParams)) {
        parent.meta.recycleRouteParams.forEach((param: string) => {
          if (!Array.isArray(param) && !Array.isArray(currentRoute.params[param])) {
            params[param] = currentRoute.params[param]
          }
        })
      }

      // SwapRouteParams allows swapping route params when navigating back to a parent route.
      // This is useful to pass a generic "id" parameter down to a child route and store
      // the parent route's id in a different parameter.
      if (parent.meta.swapRouteParams && typeof parent.meta.swapRouteParams === 'object') {
        Object.keys(parent.meta.swapRouteParams).forEach((param: string) => {
          if (currentRoute.params[param] && typeof parent.meta.swapRouteParams === 'object') {
            const set = currentRoute.params[param]
            const newParam = (parent.meta.swapRouteParams as any)[param] as string
            if (Array.isArray(set)) {
              params[newParam] = set[0]
            } else {
              params[newParam] = set
            }
          }
        })
      }

      await router.push({ name: parent.name, params })
    }
  }

  return {
    close,
    stack,
  }
}
